export default function LocalStorage() {}

LocalStorage.ns = ''; // default value
LocalStorage.enabled = true; // default value



LocalStorage.namespace = function(namespace)
{
    this.ns = namespace + '.';
    return this;
}



LocalStorage.disable = function()
{
    this.enabled = false;
    return this;
}



LocalStorage.get = function(key)
{
    if(this.enabled){
        return this.destringify(window.localStorage.getItem(`pxn.${this.ns}${key}`));
    }
}



LocalStorage.set = function(key, value)
{
    if(this.enabled){
        window.localStorage.setItem(`pxn.${this.ns}${key}`, this.stringify(value));
        return value;
    }
}



LocalStorage.stringify = function(value)
{
    if(this.isString(value)){
        return value;
    }
    return JSON.stringify(value);
}



LocalStorage.destringify = function(value)
{
    try{
        return JSON.parse(value);
    }catch(error){
        return value;
    }
}



LocalStorage.isString = function(value)
{
    return (typeof value === 'string' || value instanceof String);
}
